module.exports = __webpack_public_path__ + "img/posters.abaabb56.svg";